@if ((uniqueUsers$ | async).length > 0) {
  <div class="filter-container comment-filter-user" [formGroup]="form">
    <mat-form-field goSelect>
      <mat-label>{{ 'common_filter-by' | translate }}</mat-label>
      <mat-select
        multiple
        formControlName="selectedUsers"
        disableOptionCentering
        [placeholder]="'comment-filter-dropdown-placeholder' | translate"
        panelClass="offsetPanel commentFilterPanel">
        <mat-select-trigger>
          <!-- need this class for goSelect prepend label -->
          <span class="mat-mdc-select-min-line">
            @if (allSelected.selected) {
              <span>{{ 'common_all' | translate }}</span>
            } @else {
              <span class="num-selected-badge">{{ form.value.selectedUsers.length }}</span>
            }
          </span>
        </mat-select-trigger>
        <mat-option
          #allSelected
          (click)="toggleAll()"
          [value]="0">
          {{ 'common_all' | translate}}
        </mat-option>
        @for (user of uniqueUsers$ | async; track user) {
          <mat-option
            (click)="toggleOne()"
            [value]="user.id">
            <span>{{ user.fullname }}<small>&nbsp;({{user.count}})</small></span>
          </mat-option>
        }
      </mat-select>
      <mat-icon matIconSuffix class="ficon-app-chevron-down"></mat-icon>
    </mat-form-field>
  </div>
}
